import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Numpad } from '../../../models/numpad';
import { LocaleService } from '../../../services/locale.service';
import { FormsModule } from '@angular/forms';
import { TranslationPipe } from '../../../pipes/translation.pipe';

@Component({
    selector: 'app-numpad',
    templateUrl: './numpad.component.html',
    styleUrls: ['./numpad.component.scss'],
    imports: [FormsModule, TranslationPipe],
})
export class NumpadComponent implements OnInit {

  @Input('element') numpad: Numpad | undefined;

  firstInput = true;

  public onClose: Subject<string | null>;

  constructor(
    public bsModalRef: BsModalRef,
    public localeService: LocaleService
    ) {
    this.onClose = new Subject();
  }

  ngOnInit(): void {
    if (!this.numpad) {
      return;
    } else {
      //this.numpad.decimals = 5;
    }
  }

  number(number: number): void {
    if (!this.numpad) {
      return;
    }
    if (!this.firstInput) {
      if (this.numpad?.decimals && this.numpad.value.indexOf(this.localeService.decimalSeperator) > -1) {
        if (this.numpad.value.split(this.localeService.decimalSeperator)[1].length >= this.numpad.decimals) {
          return;
        }
      }
      this.numpad.value = this.numpad.value + number.toString();
    } else {
      this.numpad.value = number.toString();
      this.firstInput = false;
    }
  }

  comma(comma: string): void {
    if (!this.numpad) {
      return;
    }
    if (this.numpad.value.indexOf(this.localeService.decimalSeperator) > -1) {
      this.numpad.value = this.numpad.value.split(this.localeService.decimalSeperator)[0] + comma;
      return;
    }
    this.numpad.value = this.numpad.value + comma;
  }

  delete(): void {
    if (!this.numpad) {
      return;
    }
    this.numpad.value = this.numpad.value.slice(0, -1);
  }

  toggleNegative(): void {
    if (!this.numpad) {
      return;
    }
    if (this.numpad.value.indexOf('-') > -1) {
      this.numpad.value = this.numpad.value.substring(1);
    } else {
      this.numpad.value = '-' + this.numpad.value;
    }
  }

  close($event: any): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.onClose.next(null);
    this.bsModalRef?.hide();
  }

  ok($event: any): void {
    if (!this.numpad) {
      return;
    }
    $event.stopPropagation();
    $event.preventDefault();
    //const tmp: string = this.numpad.value.replace(this.localeService.decimalSeperator, '.');
    this.onClose.next(this.numpad.value);
    this.bsModalRef?.hide();
  }

}
